import Vue from 'vue'

// Lib imports
import axios from 'axios'
// import apiurl from '../../public/js/apiurl'

let apiurl = process.env.VUE_APP_BASE_URL
//let apiurl = 'http://192.168.110.132:8360/'
Vue.prototype.$http = http;
Vue.prototype.$api = apiurl;
Vue.prototype.$post = post;

function http(url, data) {

    axios.defaults.headers.common['token'] = sessionStorage.getItem('token');

    let _url = url;
    return axios.post(_url, data)
        .then(function (res) {
            return (res.data)
        })
        .catch(function (err) {
            return ({
                data: err,
                errno: 1001
            })
        })
}

function post(url, data) {

    axios.defaults.headers.common['token'] = sessionStorage.getItem('token');

    let _url = apiurl + url;
    return axios.post(_url, data)
        .then(async (res) => {
            if (res.data.errno === 1000) {
                Vue.prototype.$message({
                    showClose: true,
                    message: res.data.errmsg,
                    type: 'warning'
                });
            } else if (res.data.errno === -1) {
                if (sessionStorage.getItem('admin_name') && sessionStorage.getItem('admin_pwd')) {
                    const e = await post('admin/login', {
                        admin_name: sessionStorage.getItem('admin_name'),
                        admin_pwd: sessionStorage.getItem('admin_pwd')
                    })
                    if (e.data.errno === 0 || e.errno === 0) {
                        sessionStorage.setItem('token', e.data.token)
                        sessionStorage.setItem('uid', e.data.userInfo._id);

                        sessionStorage.setItem('role', e.data.userInfo.role);
                        sessionStorage.setItem('userInfo', JSON.stringify(e.data.userInfo));
                        post(url, data)
                    } else {
                        Vue.prototype.$router.push({
                            path: '/login'
                        })
                    }
                } else {
                    Vue.prototype.$router.push({
                        path: '/login'
                    })
                }
            }
            return (res.data)
        })
        .catch(function (err) {
            return ({
                data: err,
                errno: 1001
            })
        })
}